// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Krona+One&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  background: #232323;
  position: fixed;
  max-width: 37.5rem;
  width: 100%;
  left: 0;
  top: 0;
  height: 100vh;
  overflow: auto;
  border-right: 0.1rem solid rgba(163, 163, 163, 0.2);
}
@media (max-width: 1679px) {
  .sidebar {
    max-width: 32rem;
  }
}
@media (max-width: 1439px) {
  .sidebar {
    max-width: 28rem;
  }
}
.sidebar__logo {
  padding: 2.4rem;
  display: block;
  border-bottom: 0.1rem solid rgba(163, 163, 163, 0.2);
}
@media (max-width: 1199px) {
  .sidebar__logo {
    padding: 1.8rem;
  }
}
@media (max-width: 1199px) {
  .sidebar__logo img {
    max-width: 22rem;
  }
}
.sidebar__inner {
  display: flex;
  flex-direction: column;
  height: calc(100% - 9.5rem);
}
@media (max-width: 1199px) {
  .sidebar__inner {
    height: calc(100% - 7.5rem);
  }
}
.sidebar__inner ul {
  padding: 2.4rem;
}
@media (max-width: 1199px) {
  .sidebar__inner ul {
    padding: 1.8rem;
  }
}
.sidebar__inner ul li:not(:last-child) {
  margin-bottom: 1rem;
}
.sidebar__inner ul li a {
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 2.4rem;
  letter-spacing: -0.01em;
  color: #ffffff;
  padding: 1.2rem;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
  transition: 200ms ease-in-out;
}
.sidebar__inner ul li a::after {
  content: "";
  width: 100%;
  height: 100%;
  border-radius: inherit;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(90.71deg, #6f86de -2.07%, #4b67d1 100%);
  z-index: -1;
  opacity: 0;
  transition: opacity 200ms ease-in-out;
}
.sidebar__inner ul li a span {
  display: inline-flex;
  width: 1.8rem;
  height: 1.8rem;
  flex-shrink: 0;
  margin-right: 1rem;
}
.sidebar__inner ul li a span svg {
  width: 100%;
  height: 100%;
}
.sidebar__inner ul li a span svg path {
  transition: 200ms ease-in-out;
}
@media (max-width: 1199px) {
  .sidebar__inner ul li a {
    font-size: 1.6rem;
    padding: 1.4rem 1.6rem;
    font-weight: 500;
  }
  .sidebar__inner ul li a span {
    width: 1.8rem;
    height: 1.8rem;
  }
}
.sidebar__inner ul li a.active, .sidebar__inner ul li a:hover {
  color: #ffffff;
}
.sidebar__inner ul li a.active::after, .sidebar__inner ul li a:hover::after {
  opacity: 1;
}
.sidebar__inner ul li a.not_fill.active svg path, .sidebar__inner ul li a.not_fill:hover svg path {
  fill: none;
  stroke: #ffffff;
}
.sidebar__inner__bottom {
  padding: 2.4rem;
  margin-top: auto;
  border-top: 0.1rem solid rgba(163, 163, 163, 0.2);
}
@media (max-width: 1199px) {
  .sidebar__inner__bottom {
    padding: 1.8rem;
  }
}
@media (min-width: 1200px) {
  .sidebar {
    transform: none !important;
  }
}
@media (max-width: 1199px) {
  .sidebar {
    transform: translateX(-100%);
    z-index: 991;
    transition: 200ms ease-in-out;
    background: transparent;
    border-right: none;
    max-width: 35rem;
  }
  .sidebar.active {
    transform: none;
  }
  .sidebar .token_icon {
    max-width: 10rem;
  }
}
@media (max-width: 575px) {
  .sidebar {
    max-width: 100%;
  }
}

.sidebar_bg {
  background: #232323;
  height: 100%;
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 990;
}

.overlay {
  position: fixed;
  top: 0;
  z-index: 989;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  transition: 200ms ease-in-out;
  -webkit-backdrop-filter: blur(1rem);
          backdrop-filter: blur(1rem);
  opacity: 0;
  visibility: hidden;
}
.overlay.active {
  opacity: 1;
  visibility: visible;
}`, "",{"version":3,"sources":["webpack://./src/Components/UI/Sidebar/Sidebar.scss","webpack://./src/Assets/Theme/_var.scss"],"names":[],"mappings":"AAEA;EACE,mBCSW;EDRX,eAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,cAAA;EACA,mDAAA;AAAF;AAEE;EAXF;IAYI,gBAAA;EACF;AACF;AAAE;EAdF;IAeI,gBAAA;EAGF;AACF;AAFE;EACE,eAAA;EACA,cAAA;EACA,oDAAA;AAIJ;AAHI;EAJF;IAKI,eAAA;EAMJ;AACF;AAHM;EADF;IAEI,gBAAA;EAMN;AACF;AAFE;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;AAIJ;AAFI;EALF;IAMI,2BAAA;EAKJ;AACF;AAHI;EACE,eAAA;AAKN;AAJM;EAFF;IAGI,eAAA;EAON;AACF;AAJQ;EACE,mBAAA;AAMV;AAHQ;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cCtDF;EDuDE,eAAA;EAEA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,6BAAA;AAIV;AAFU;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EAEA,SAAA;EACA,gCAAA;EACA,mEC7CD;ED8CC,WAAA;EACA,UAAA;EACA,qCAAA;AAGZ;AAAU;EACE,oBAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAEZ;AACY;EACE,WAAA;EACA,YAAA;AACd;AAAc;EACE,6BAAA;AAEhB;AAGU;EAhDF;IAiDI,iBAAA;IACA,sBAAA;IACA,gBAAA;EAAV;EAEU;IACE,aAAA;IACA,cAAA;EAAZ;AACF;AAGU;EAEE,cC9GJ;AD4GR;AAIY;EACE,UAAA;AAFd;AAgBgB;EACE,UAAA;EACA,eCjIV;ADmHR;AAsBI;EACE,eAAA;EACA,gBAAA;EACA,iDAAA;AApBN;AAqBM;EAJF;IAKI,eAAA;EAlBN;AACF;AAsBE;EAtJF;IAuJI,0BAAA;EAnBF;AACF;AAqBE;EA1JF;IA2JI,4BAAA;IACA,YC/GM;IDgHN,6BAAA;IACA,uBAAA;IACA,kBAAA;IACA,gBAAA;EAlBF;EAoBE;IACE,eAAA;EAlBJ;EAqBE;IACE,gBAAA;EAnBJ;AACF;AAsBE;EA3KF;IA4KI,eAAA;EAnBF;AACF;;AAsBA;EACE,mBCvKW;EDwKX,YAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,MAAA;EACA,YC/IgB;EDgJhB,OAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,6BAAA;EACA,mCAAA;UAAA,2BAAA;EACA,UAAA;EACA,kBAAA;AAnBF;AAqBE;EACE,UAAA;EACA,mBAAA;AAnBJ","sourcesContent":["@import \"../../../Assets/Theme/_var.scss\";\n\n.sidebar {\n  background: $secondary2;\n  position: fixed;\n  max-width: 37.5rem;\n  width: 100%;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  overflow: auto;\n  border-right: 0.1rem solid rgba($secondary3, 0.2);\n\n  @media (max-width: 1679px) {\n    max-width: 32rem;\n  }\n  @media (max-width: 1439px) {\n    max-width: 28rem;\n  }\n  &__logo {\n    padding: 2.4rem;\n    display: block;\n    border-bottom: 0.1rem solid rgba($secondary3, 0.2);\n    @media (max-width: 1199px) {\n      padding: 1.8rem;\n    }\n\n    img {\n      @media (max-width: 1199px) {\n        max-width: 22rem;\n      }\n    }\n  }\n\n  &__inner {\n    display: flex;\n    flex-direction: column;\n    height: calc(100% - 9.5rem);\n\n    @media (max-width: 1199px) {\n      height: calc(100% - 7.5rem);\n    }\n\n    ul {\n      padding: 2.4rem;\n      @media (max-width: 1199px) {\n        padding: 1.8rem;\n      }\n\n      li {\n        &:not(:last-child) {\n          margin-bottom: 1rem;\n        }\n\n        a {\n          font-size: 1.6rem;\n          font-weight: 500;\n          line-height: 2.4rem;\n          letter-spacing: -0.01em;\n          color: $white;\n          padding: 1.2rem;\n\n          border-radius: 1rem;\n          display: flex;\n          align-items: center;\n          position: relative;\n          z-index: 1;\n          transition: 200ms ease-in-out;\n\n          &::after {\n            content: \"\";\n            width: 100%;\n            height: 100%;\n            border-radius: inherit;\n            position: absolute;\n            top: 50%;\n\n            left: 50%;\n            transform: translate(-50%, -50%);\n            background: $gradient;\n            z-index: -1;\n            opacity: 0;\n            transition: opacity 200ms ease-in-out;\n          }\n\n          span {\n            display: inline-flex;\n            width: 1.8rem;\n            height: 1.8rem;\n            flex-shrink: 0;\n            margin-right: 1rem;\n            // transform: translateY(-0.1rem);\n\n            svg {\n              width: 100%;\n              height: 100%;\n              path {\n                transition: 200ms ease-in-out;\n              }\n            }\n          }\n\n          @media (max-width: 1199px) {\n            font-size: 1.6rem;\n            padding: 1.4rem 1.6rem;\n            font-weight: 500;\n\n            span {\n              width: 1.8rem;\n              height: 1.8rem;\n            }\n          }\n\n          &.active,\n          &:hover {\n            color: $white;\n\n            &::after {\n              opacity: 1;\n            }\n\n            svg {\n              path {\n                // fill: $white;\n              }\n            }\n          }\n\n          &.not_fill {\n            &.active,\n            &:hover {\n              svg {\n                path {\n                  fill: none;\n                  stroke: $white;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    &__bottom {\n      padding: 2.4rem;\n      margin-top: auto;\n      border-top: 0.1rem solid rgba($secondary3, 0.2);\n      @media (max-width: 1199px) {\n        padding: 1.8rem;\n      }\n    }\n  }\n\n  @media (min-width: 1200px) {\n    transform: none !important;\n  }\n\n  @media (max-width: 1199px) {\n    transform: translateX(-100%);\n    z-index: $sidebar;\n    transition: 200ms ease-in-out;\n    background: transparent;\n    border-right: none;\n    max-width: 35rem;\n\n    &.active {\n      transform: none;\n    }\n\n    .token_icon {\n      max-width: 10rem;\n    }\n  }\n\n  @media (max-width: 575px) {\n    max-width: 100%;\n  }\n}\n\n.sidebar_bg {\n  background: $secondary2;\n  height: 100%;\n  position: fixed;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: $sidebar - 1;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  z-index: $sidebar_overlay;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba($black, 0.3);\n  transition: 200ms ease-in-out;\n  backdrop-filter: blur(1rem);\n  opacity: 0;\n  visibility: hidden;\n\n  &.active {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Krona+One&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n$baseFont: \"Poppins\", sans-serif;\n$baseFont2: \"Krona One\", sans-serif;\n\n$white: #ffffff;\n$black: #000000;\n$primary: #6d8afa;\n$primary2: #6f86de;\n$lightGray: #bdbdbd;\n$lightGray2: #d1d1d1;\n$secondary: #252a3a;\n$secondary2: #232323;\n$secondary3: #a3a3a3;\n$secondary4: #727272;\n$secondary5: #292c2e;\n$secondarybg: #171b27;\n$secondarybg2: #22283a;\n$secondarybg3: #202535;\n$secondarybg4: #172545;\n$borderClr: #262626;\n$borderClr2: #252525;\n$borderClr3: #28343e;\n\n$green: #7bbb3f;\n$blue: #2797d1;\n$red: #c3292d;\n$orange: #f68630;\n$skyblue: #01cde4;\n$yellowdark: #fbbb10;\n$reddark: #e54c40;\n\n$btnGradient: linear-gradient(270deg, #fde679 -0.16%, #f26c33 86.5%);\n\n$gradient: linear-gradient(90.71deg, #6f86de -2.07%, #4b67d1 100%);\n$gradient2: linear-gradient(0deg, rgba(0, 0, 0, 0) -29.92%, #161616 97.38%);\n$gradient3: linear-gradient(90deg, #fde076 1.57%, rgba(242, 107, 51, 0) 101.1%);\n$gradient4: linear-gradient(261.01deg, #212122 2.84%, rgba(0, 0, 0, 0) 165.67%);\n\n$boxShadow: 0 1.2rem 1.6rem -0.4rem rgba(255, 255, 255, 0.2),\n  0 0.4rem 0.6rem -0.2rem rgba(255, 255, 255, 0.15);\n$boxShadow2: 0 1rem 1.4rem rgba(255, 255, 255, 0.06);\n$boxShadow3: inset 3px 17px 37px rgba(3, 3, 3, 0.6),\n  inset 0px 0px 5px rgba(255, 255, 255, 0.1);\n\n// z indexes\n$header: 988;\n$sidebar: $header + 3;\n$sidebar_overlay: $sidebar - 2;\n$modal: 1056;\n$loader: 1090;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
